/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

export const contrastingForegroundColor = (bgColor, limit = 0.5) => {
  if (!bgColor) { 
    return '#000000';
  }

  // Remove any leading # from the color string
  const color = bgColor.replace(/^#/, '');

  // Convert the color to RGB values
  const red = parseInt(color.substr(0, 2), 16);
  const green = parseInt(color.substr(2, 2), 16);
  const blue = parseInt(color.substr(4, 2), 16);

  // Calculate the relative luminance using the formula
  const luminance = (0.299 * red + 0.587 * green + 0.114 * blue) / 255;

  return luminance > limit ? '#000000' : '#ffffff'; // Return black or white based on luminance value
};
